import luxuryescapes from './luxuryescapes'
import cudotravel from './cudotravel'
import dealstravel from './dealstravel'
import treatmetravel from './treatmetravel'
import scoopontravel from './scoopontravel'
import leagenthub from './leagenthub'
import leagenthubCVFR from './leagenthub_cvfr'

const allThemes: { [brand: string]: App.Design.Theme } = {
  luxuryescapes,
  cudotravel,
  dealstravel,
  treatmetravel,
  scoopontravel,
  leagenthub,
  leagenthub_cvfr: leagenthubCVFR,
}

export default allThemes
